// src/components/CodeEditor.jsx
import React, { useEffect, useRef } from 'react';
import { EditorView, basicSetup } from 'codemirror';
import { EditorState } from '@codemirror/state';
import { javascript } from '@codemirror/lang-javascript';
import { oneDark } from '@codemirror/theme-one-dark';

const CodeEditor = ({ initialDoc = '', onChange }) => {
  const editorRef = useRef(null);
  const viewRef = useRef(null);

  useEffect(() => {
    if (!editorRef.current) return;
  
    const startState = EditorState.create({
      doc: initialDoc,
      extensions: [
        basicSetup,
        javascript(),
        oneDark,
        EditorView.updateListener.of((update) => {
          if (update.changes && onChange) {
            onChange(update.state.doc.toString());
          }
        }),
      ],
    });
  
    viewRef.current = new EditorView({
      state: startState,
      parent: editorRef.current,
    });
  
    return () => {
      if (viewRef.current) {
        viewRef.current.destroy();
      }
    };
    // Run this effect only once
  }, []);

  return <div ref={editorRef} />;
};

export default CodeEditor;
